const objMap = (fun) => (data) =>
  Object.keys(data).map((key) => fun(key, data[key]));

export default objMap;
